module.exports = __webpack_public_path__ + "assets/edd20633c781412d2d944ae192556556.png";